import { render, staticRenderFns } from "./new.vue?vue&type=template&id=4f842ffe&scoped=true&"
import script from "./new.vue?vue&type=script&lang=js&"
export * from "./new.vue?vue&type=script&lang=js&"
import style0 from "./new.vue?vue&type=style&index=0&id=4f842ffe&prod&lang=scss&"
import style1 from "./new.vue?vue&type=style&index=1&id=4f842ffe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f842ffe",
  null
  
)

export default component.exports